import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../../../settings/index';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import Api, { executeAction } from '../../../../../../helpers/api';
import { t } from '../../../../../../i18n';
import { TABS } from './poolList';

const api = new Api('bookings/:id/booking_pools');
const teamMembersApi = new Api('bookings/:id/booking_pools/team_members');
const bulkActionsApi = new Api('bookings/:id/booking_pools/actions');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id, isLoadMore = false } = payload;
    const search = { ...payload, page, pageSize, column, order, filter };

    const result = yield call(sendRequest, api.load, { search, id }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      const {
        records,
        totalCount,
        filteredCount,
        sortableColumns,
        filters,
        actions: bulkActions,
        bulk_actions_enabled,
      } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
          page,
          pageSize,
          isLoadMore,
          bulkActions,
          bulk_actions_enabled,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadMyTeamData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = payload;
    const search = { ...payload, page, pageSize, column, order, filter };

    const result = yield call(sendRequest, teamMembersApi.load, { search, id }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters } = result.data.success.data;

      yield put(
        actions.loadMyTeamDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* sendPoolRequest({ payload }) {
  try {
    const { url, method, data, key, tab } = payload;

    const result = yield call(sendRequest, executeAction, { url, method, data }, notifications.REQUEST_ERROR);
    const message = '';

    if (result?.messages || result?.success) {
      if (key === 'invite') {
        if (tab === TABS.all) {
          yield put(actions.toggleBulkInviteAlertVisibility({ visibility: true }));
        }
      }

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: message || result.messages.join(' '),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadAvailableActions({ payload }) {
  try {
    const { bookingId, data } = payload;

    const result = yield call(
      sendRequest,
      bulkActionsApi.load,
      { id: bookingId, search: data },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      yield put(
        actions.loadAvailableActionSuccess({
          availableActions: result?.data?.success?.data?.actions,
          availableStatuses: result?.data?.success?.data?.statuses_to_select_by,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.LOAD_MY_TEAM_REQUEST, loadMyTeamData),
    takeEvery(actions.SEND_REQUEST, sendPoolRequest),
    takeEvery(actions.LOAD_AVAILABLE_ACTION_REQUEST, loadAvailableActions),
  ]);
}
